import type { QueryHookOptions } from "@apollo/client"
import { useQuery } from "@apollo/client"
import query from "@/v2-backoffice-client/customer/pricing/customer.pricing.query.gql"
import type {
  CustomerPricingQuery,
  CustomerPricingQueryVariables,
} from "@/v2-backoffice-client/customer/pricing/__types__/customer.pricing.query"

type Options = QueryHookOptions<
  CustomerPricingQuery,
  CustomerPricingQueryVariables
>

// The customer panel's "What they pay" section: every live Fenerum
// subscription behind the customer's licenses, list price next to what is
// billed, with the deal or contract behind the difference.
export function useCustomerPricingQuery(options?: Options) {
  return useQuery<CustomerPricingQuery, CustomerPricingQueryVariables>(
    query,
    options,
  )
}
